function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M90.658 12H29.993C25.587 12 22 15.587 22 19.993v43.081c0 4.406 3.587 7.993 7.993 7.993h21.833l-2.261 7.993h-5.186v3.197H76.31v-3.198h-5.185l-2.261-7.992h21.833c4.406 0 7.992-3.587 7.992-7.993V19.993C98.612 15.587 95.064 12 90.658 12zm-37.78 67.02l2.262-7.992h10.37l2.262 7.992H52.878zm42.537-15.946a4.792 4.792 0 01-4.796 4.796H29.993a4.792 4.792 0 01-4.796-4.796v-3.197h70.218v3.197zm0-6.394H25.197V19.993a4.792 4.792 0 014.796-4.796h60.626a4.792 4.792 0 014.796 4.796V56.68zM73.074 85.415h-44.68a1.58 1.58 0 00-1.599 1.598v19.143c0 .897.702 1.599 1.599 1.599h44.68c.897 0 1.599-.702 1.599-1.599V87.013c0-.897-.702-1.598-1.599-1.598zm-1.598 19.143H29.992V88.612h41.484v15.946z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.386 98.203H33.19v3.197h3.197v-3.197zM36.386 91.81H33.19v3.196h3.197V91.81zM42.78 91.81h-3.197v3.196h3.198V91.81zM49.175 91.81h-3.197v3.196h3.197V91.81zM61.924 91.81h-3.197v3.196h3.197V91.81zM55.53 91.81h-3.197v3.196h3.197V91.81zM68.318 98.203h-3.197v3.197h3.197v-3.197zM68.318 91.81h-3.197v3.196h3.197V91.81zM61.924 98.203h-22.34v3.197h22.34v-3.197zM85.863 85.415c-4.406 0-7.993 3.586-7.993 7.992v6.394c0 4.406 3.587 7.993 7.993 7.993 4.405 0 7.992-3.587 7.992-7.993v-6.394c0-4.406-3.587-7.992-7.992-7.992zM90.658 99.8a4.793 4.793 0 01-4.795 4.796 4.793 4.793 0 01-4.796-4.796v-6.394a4.792 4.792 0 014.796-4.795 4.792 4.792 0 014.795 4.795v6.394z",
  fill: "#384B51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M87.461 91.81h-3.197v3.196h3.197V91.81z",
  fill: "#384B51"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M55.569 48.298l6.394-22.34 3.08.896-6.394 22.34-3.08-.896zM51.787 30.792l-2.028-2.456-9.59 7.992a1.602 1.602 0 00-.196 2.262c.078.078.117.156.195.195l9.591 7.992 2.028-2.456-8.11-6.745 8.11-6.784zM80.716 36.523c-.078-.078-.117-.156-.195-.195l-9.59-7.992-2.028 2.456 8.11 6.745-8.11 6.745 2.027 2.456 9.591-7.992c.663-.546.741-1.56.195-2.223z",
  fill: "#00BAC3"
});

function SvgDesktopLink(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgDesktopLink;